import styled from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  margin: 1rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (min-width: 768px) {
    margin: 1rem 2rem 2rem;
  }
`;

export const CardProperty = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5rem;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  width: 100%;
  border-radius: 10px;
  word-wrap: break-word;
  margin: 1rem 0;

  @media (min-width: 768px) {
    width: 280px;
  }
`;

export const CardContent = styled.div`
  p {
    color: ${({ theme }) => theme.colors.gray};
    margin-bottom: 0;

    & + p {
      font-size: 1rem;
      margin-top: 0.5rem;
    }
  }
`;

export const CardFooter = styled.div`
  /* button {
    background-color: ${({ theme }) => theme.colors.transactionPrimary};
    padding: 0.5rem;
    border-radius: 50%;
    border: 0;

    svg {
      color: ${({ theme }) => theme.colors.white};
      width: 17px;
      height: 17px;
    }
  } */

  > div {
    display: flex;
  }

  button + button {
    margin-left: 1rem;
  }
`;

export const Line = styled.div`
  margin: 1rem 0;
  height: 1px;
  width: 100%;
  border-radius: 1px;
  background-color: ${({ theme }) => theme.colors.gray};
  opacity: 0.2;
`;

export const NoProperty = styled.p`
  font-size: 1.5rem;
  margin-top: 1rem;
  color: ${({ theme }) => theme.colors.gray};
`;
